module.exports = __webpack_public_path__ + "static/media/jerry2.999e3fbe.png";